<ppl-dialog-message
  type="confirm"
  description="Entering this space requires additional {{ idpName }} authentication."
  i18n-description="@@ConfirmAdditionalSpaceAuthenticationDescription"
  actionLabel="Continue"
  i18n-actionLabel="@@Continue"
  (action)="dialogRef.close(changeIdpProvider ? CONFIRM_SPACE_AUTH_DIALOG.WITH_DEFAULT_IDP_CHANGE : CONFIRM_SPACE_AUTH_DIALOG.WITHOUT_DEFAULT_IDP_CHANGE)">
  <ppl-form-container>
    <ppl-form-row>
      <ppl-form-column>
        <ppl-checkbox
          [value]="changeIdpProvider"
          i18n="@@ConfirmAdditionalSpaceAuthenticationCheckboxDescription"
          (valueChange)="changeIdpProvider = !changeIdpProvider; changeDetectorRef.detectChanges()"
          >Make {{ idpName }} authentication default for faster authentication</ppl-checkbox
        >
      </ppl-form-column>
    </ppl-form-row>
  </ppl-form-container>
</ppl-dialog-message>
